module.exports = __webpack_public_path__ + "media/markers/marker-cluster-gray-blue-663be49c.svg";